<template>
  <FormGroup>
    <FormField class="sm:col-span-6" field="upload" :errors="errors">
      <template #label>
        Profilbild
      </template>
      <template #input="props">
        <FileUpload v-model="value" accept="image/*" id="upload" :class="props['class']"/>
      </template>
    </FormField>
  </FormGroup>
</template>

<script setup>
import { ref, watch } from 'vue';
const props = defineProps(['modelValue', 'errors']);
const emits = defineEmits(['update:modelValue']);
const value = ref(props.modelValue);
const emitter = (v) => emits('update:modelValue', v);
const changed = watch(value, emitter);
</script>
